module.exports = __webpack_public_path__ + "static/img/8.4db34bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/8.jpg
// module id = RzIU
// module chunks = 5